import { render } from "./MCheckbox.vue?vue&type=template&id=284d7556"
import script from "./MCheckbox.vue?vue&type=script&lang=js"
export * from "./MCheckbox.vue?vue&type=script&lang=js"

import "./MCheckbox.vue?vue&type=style&index=0&id=284d7556&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__